import { render, staticRenderFns } from "./TutorInfo.vue?vue&type=template&id=575a387e&scoped=true"
import script from "./TutorInfo.vue?vue&type=script&lang=ts"
export * from "./TutorInfo.vue?vue&type=script&lang=ts"
import style0 from "./TutorInfo.vue?vue&type=style&index=0&id=575a387e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a387e",
  null
  
)

export default component.exports